<template>
  <div
    v-if="$options.filters.not_empty(data)"
    :style="{
      backgroundImage: `url(\'${$options.filters.image_by_id(data.banner_img, $store.state)}\')`,
    }"
    class="bottom-banner sides-padding"
  >
    <div class="bottom-banner__content">
      <span class="bottom-banner__logo">
        <ImgComponent :head_img="data.head_img" />
      </span>
      <span class="bottom-banner__description">
        {{ data.description }}
      </span>
      <router-link :to="{ name: 'catalog', query: { brands_item_id: data.id } }" class="bottom-banner__link">
        Перейти в каталог
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "BottomBannerComponent",
  props: {
    data: Object,
  },
};
</script>

<style lang="stylus">
@import "~@/styles/mixins/maxlines.styl"
.bottom-banner {
  //background: url("/static/images/bottom_banner.jpg") no-repeat center / cover
  background-repeat no-repeat
  background-position center
  background-size cover
  background-color var(--gray)
  padding-top 84px
  padding-bottom 94px
  display flex
  justify-content center
  align-items center
  +below(840px) {
    padding 50px 30px
  }
  +below(480px) {
    padding 30px
  }

  &__content {
    background: var(--white_o8)
    backdrop-filter: blur(4px);
    border-radius: var(--big_radius)
    padding 30px
    display flex
    flex-direction column
    gap 20px
    align-items center
    text-align center
    max-width 363px
    font-size: 0.875em
    line-height: 145%;
    +below(840px) {
      gap 15px
    }
    +below(420px) {
      font-size: 0.75em
      padding 30px 20px
    }
  }

  &__logo {
    .img {
      width 80px
      height auto
      +below(420px) {
        width 60px
      }
    }
  }

  &__description {
    maxlines(6)
  }

  &__link {
    text-decoration underline
  }
}
</style>
